export interface SuratKeteranganMainDataModel {
  ulid: string;
  nama: string;
  deskripsi: string;
  path: string;
  created_at: string;
  updated_at: string;
  original_filename: string;
  file_url: string;
}

export interface NotificationMessage {
  id: number;
  ulid: string;
  user_id: number;
  type: string;
  properties: Properties;
  read_at: any;
  created_at: string;
  updated_at: string;
}

export interface Properties {
  id: string;
  ulid: string;
  notes: string;
  action: string;
}

export interface SuratKeteranganModel {
  main: {
    data: SuratKeteranganMainDataModel[];
    total: number;
  };
  notification: {
    data: NotificationMessage[];
  };
  detail: {
    data: SuratKeteranganMainDataModel;
  };
}

export enum SuratKeteranganActionType {
  GetAllSuratKeterangan = "⌘➝SK➝GetAllSuratKeterangan",
  GetDetailSuratKeterangan = "⌘➝SK➝GetDetailSuratKeterangan",
  GetHistoryNotification = "⌘➝SK➝GetHistoryNotification",
}

export type SuratKeteranganAction =
  | {
      data: {
        data: SuratKeteranganMainDataModel[];
        total: number;
      };
      type: SuratKeteranganActionType.GetAllSuratKeterangan;
    }
  | {
      data: {
        data: SuratKeteranganMainDataModel;
      };
      type: SuratKeteranganActionType.GetDetailSuratKeterangan;
    }
  | {
      data: {
        data: NotificationMessage[];
      };
      type: SuratKeteranganActionType.GetHistoryNotification;
    };
